import React from 'react';
import _ from "lodash";
import SweetAlert from 'react-bootstrap-sweetalert';

import withStyles from "@material-ui/core/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class SweetAlertModal extends React.Component{
	constructor(props){
		super(props);
	}

	render(){
		const { show, message, status, confirmBtn, content } = this.props;

		const alert = (show) ? 
				<SweetAlert 
					danger
					style={{ display: "block", marginTop: "-100px"}}
					title={!_.isEmpty(message) ? message : "Oooops! There was an issue!"}
					onConfirm={confirmBtn}
				>
					{!_.isEmpty(content) ? content : 'Contact PE for more information.'}
				</SweetAlert> 
				: null

		return(
			<div>
				{alert}
			</div>
		)
	}

}
export default withStyles(sweetAlertStyle)(SweetAlertModal);


// WEBPACK FOOTER //
// ./src/views/etc/modals/SweetAlert.jsx